import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Trends from '../Components/Trends'
import banner_image_insight from "../images/banner_images/laptop/insights.png"
import card_image_1 from "../images/Insights/card_image_1.png"
import card_image_2 from "../images/Insights/card_image_2.png"
import card_image_3 from "../images/Insights/card_image_3.png"
import card_image_4 from "../images/Insights/card_image_4.png"
import WorkspaceBanner from "../Components/WorkspaceBanner"

// import ExploreButton from "../Utils/explore";`

function Insights () {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])

    const insightCard = [
        {
            src:card_image_1,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur.",
            content:"Lorem ipsum dolor sit amet consectetur. Sed id facilisi integer habitant lorem consectetur etiam. Volutpat orci viverra integer magna pharetra in egestas quis.",
        },
        {
            src:card_image_2,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur.",
            content:"Lorem ipsum dolor sit amet consectetur. Sed id facilisi integer habitant lorem consectetur etiam. Volutpat orci viverra integer magna pharetra in egestas quis.",
        },
        {
            src:card_image_3,
            date:"june 15,2023",
            heading:"Cursus volutpat consectetur sapien tellus mauris quis fringilla tellus hendrerit.",
            content:"Lorem ipsum dolor sit amet consectetur. Sed id facilisi integer habitant lorem consectetur etiam. Volutpat orci viverra integer magna pharetra in egestas quis.",
        },
        {
            src:card_image_4,
            date:"june 15,2023",
            heading:"Cursus volutpat consectetur sapien tellus mauris quis fringilla tellus hendrerit.",
            content:"Lorem ipsum dolor sit amet consectetur. Sed id facilisi integer habitant lorem consectetur etiam. Volutpat orci viverra integer magna pharetra in egestas quis.",
        },
    ]

    return(
    <>
    
        <img className="w-full h-[450px] object-cover" src={banner_image_insight}  alt="BannerImage"/> 

        <div className="max-w-4xl mx-auto px-6 my-10 text-center" data-aos="fade-up">
            <h2 className="section-heading mt-6 py-8">Trends <span className="font-[timesnewroman]">&</span> Insights</h2>
            <div className="flex justify-center" data-aos="fade-up" data-aos-duration="1100">
                <div className="py-1 px-4 border-l border-[#B1B2B4]">Latest</div>
                <div className="py-1 px-4 border-l border-[#B1B2B4]">Workplace</div>
                <div className="py-1 px-4 border-l border-[#B1B2B4]">Cities</div>
                <div className="py-1 px-4 border-x border-[#B1B2B4]">Research</div>
            </div>
        </div>

        {/* Coimbatore Focus */}
        <div className="max-w-[1323px] mx-auto px-6">
            <div className="my-16 md:my-24">
                <h1 className="font-[merriweather] text-[38px] text-center lg:text-left lg:text-[52px]" data-aos="fade-up">Coimbatore in focus</h1>

                <div className="flex justify-center flex-wrap my-4 md:justify-around" data-aos="fade-up">
                    {
                    insightCard.map((items) => {
                        return(
                            <div className="font-[lato] w-[309px] h-[450px] relative mt-10"> {/* Responsive align check */}
                                <img src={items.src} alt="cardimage"/>
                                <p className="text-font-grey text-[12px] uppercase py-2">{items.date}</p>
                                <h2 className="text-[20px] font-medium leading-[24px] py-1">{items.heading}</h2>
                                <p className="text-font-grey text-[14px] leading-[21px] mt-2 py-2">{items.content}</p>

                                <div className="lg:absolute bottom-0">
                                    <button className="bg-yellow text-[10.5px] uppercase tracking-[1px] mt-4 py-2 px-4">view more</button>
                                </div>
                            </div> 
                        );
                    })}
                </div>
            </div>
        
            {/* Future of real estate */}
            <div className="my-24">
                <h1 className="font-[merriweather] text-[38px] text-center lg:text-left lg:text-[52px]" data-aos="fade-up">Future of real estate</h1>

                <div className="flex justify-center flex-wrap my-4 md:justify-around" data-aos="fade-up">
                    {
                    insightCard.map((items) => {
                        return(
                            <div className="font-[lato] w-[309px] h-[450px] relative mt-10"> {/* Responsive align check */}
                                <img src={items.src} alt="cardimage"/>
                                <p className="text-font-grey text-[12px] uppercase py-2">{items.date}</p>
                                <h2 className="text-[20px] font-medium leading-[24px] py-1">{items.heading}</h2>
                                <p className="text-font-grey text-[14px] leading-[21px] mt-2 py-2">{items.content}</p>

                                <div className="lg:absolute bottom-0">
                                    <button className="bg-yellow text-[10.5px] uppercase tracking-[1px] mt-4 py-2 px-4">view more</button>
                                </div>
                            </div> 
                        );
                    })}
                </div>
            </div>

            {/* Planning */}
            <WorkspaceBanner />
            
            
        </div>

        <Trends />

    </>
    );
}

export default Insights ;
